import { Time } from '@angular/common';
import { Timeslot } from '../shared/Timeslot';


export function compareTimeslotStart(a: Timeslot, b: Timeslot): number {
  if (a.start.hours != b.start.hours) {
    return a.start.hours - b.start.hours;
  }
  if (a.start.minutes != b.start.minutes) {
    return a.start.minutes - b.start.minutes;
  }
  return 0;
}

export function compareTimeslotStartEnd(a: Timeslot, b: Timeslot): number {
  if (a.date.getTime() != b.date.getTime()) {
    return a.date.getTime() - b.date.getTime();
  }
  if (a.start.hours != b.start.hours) {
    return a.start.hours - b.start.hours;
  }
  if (a.start.minutes != b.start.minutes) {
    return a.start.minutes - b.start.minutes;
  }
  if (a.end.hours != b.end.hours) {
    return a.end.hours - b.end.hours;
  }
  if (a.end.minutes != b.end.minutes) {
    return a.end.minutes - b.end.minutes;
  }
  return 0;
}

export function parseDate(input: [number, number, number]): Date {
  return new Date(input[0], input[1] - 1, input[2]);
}

export function parseTime(input: [number, number, number?, number?]): Time {
  return { hours: input[0], minutes: input[1] };
}

export function dateToArray(input: Date): [number, number, number] {
  return [input.getFullYear(), input.getMonth() + 1, input.getDate()];
}

export function timeToArray(input: Time): [number, number] {
  return [input.hours, input.minutes];
}
